export const prompt = (message: string, title?: string, defaultText?: string) => {
    return new Promise<string | null>((resolve) => {
        const result = window.prompt(message, defaultText);
        resolve(result);
    });
};
